/**
 * @generated SignedSource<<2ab00c1c4f9a41e7273bfe6a75783804>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InterstitialNotificationsTable_refetchableBrand$data = {
  readonly id: string;
  readonly interstitialNotifications: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"InterstitialNotificationTableRow_notification">;
      };
    }>;
    readonly totalCount: number | null;
  };
  readonly " $fragmentType": "InterstitialNotificationsTable_refetchableBrand";
};
export type InterstitialNotificationsTable_refetchableBrand$key = {
  readonly " $data"?: InterstitialNotificationsTable_refetchableBrand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InterstitialNotificationsTable_refetchableBrand">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "interstitialNotifications"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "audienceFilter"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "languageFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./InterstitialNotificationsTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "InterstitialNotificationsTable_refetchableBrand",
  "selections": [
    {
      "alias": "interstitialNotifications",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "audienceIds",
              "variableName": "audienceFilter"
            },
            {
              "kind": "Variable",
              "name": "audienceLanguages",
              "variableName": "languageFilter"
            },
            {
              "kind": "Literal",
              "name": "isArchived",
              "value": false
            }
          ],
          "kind": "ObjectValue",
          "name": "filters"
        }
      ],
      "concreteType": "GraphQLInterstitialNotificationConnection",
      "kind": "LinkedField",
      "name": "__InterstitialNotificationTable_interstitialNotifications_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLInterstitialNotificationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLInterstitialNotification",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "InterstitialNotificationTableRow_notification"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "5ad1795093eb100835a5385a36e46ceb";

export default node;
